var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-success-page"},[_c('div',{staticClass:"loader-block"},[_c('h3',[_vm._v(_vm._s(_vm.$t('Авторизация через ЕСИ...')))]),_c('div',{staticClass:"spinner"}),_c('p',[_vm._v(_vm._s(_vm.$t('Пожалуйста, подождите')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }